export const selectUser = (state) => [state.user, state.setUser]
export const selectToken = (state) => [state.token, state.setToken]
export const selectRole = (state) => state.user?.role
export const selectIsAuthenticated = (state) => [state.isAuthenticated, state.setIsAuthenticated]
export const selectBasicAuthenticated = (state) => [state.basicAuthenticated, state.setBasicAuthenticated]